import React, { useState, useRef, useEffect } from 'react';
import classnames from 'classnames';
export var AutoSizedText = function (_a) {
    var children = _a.children, className = _a.className, tooBigClassName = _a.tooBigClassName, maxHeight = _a.maxHeight;
    var _b = useState(false), isTooBig = _b[0], setIsTooBig = _b[1];
    var _c = useState(false), hasTriggeredResize = _c[0], setHasTriggeredResize = _c[1];
    var rootRef = useRef(null);
    useEffect(function () {
        var node = rootRef.current;
        if (!node) {
            return;
        }
        var isTooBigNow = node.getBoundingClientRect().height > maxHeight;
        // hasTriggeredResize here to avoid infinite loops between adding the tooBig class and removing it
        // at certain viewport sizes
        if (isTooBigNow === isTooBig || hasTriggeredResize) {
            return;
        }
        setIsTooBig(isTooBigNow);
        setHasTriggeredResize(true);
    }, [rootRef, isTooBig, hasTriggeredResize, maxHeight]);
    return (React.createElement("h1", { ref: rootRef, className: classnames(className, isTooBig && tooBigClassName) }, children));
};
export default AutoSizedText;
//# sourceMappingURL=AutoSizedText.js.map